/**
 * 環境変数のヘルパー関数
 */

/**
 * 管理画面のログインURLを取得
 * デフォルト: /admin/login
 */
export const getAdminLoginPath = (): string => {
  return '/admin/login';
};

/**
 * 管理画面の記事一覧URLを取得
 * デフォルト: /admin/posts
 */
export const getAdminPostsPath = (): string => {
  return '/admin/posts';
};

/**
 * ユーザー向けホームURLを取得
 * 環境変数 VITE_USER_HOME_PATH から取得
 * デフォルト: /
 */
export const getUserHomePath = (): string => {
  // 環境変数が明示的に設定されている場合はそれを使用
  if (import.meta.env.VITE_USER_HOME_PATH) {
    return import.meta.env.VITE_USER_HOME_PATH;
  }
  // デフォルトは /
  return '/';
};

/**
 * ユーザー向け記事詳細URLのベースパスを取得
 * 環境変数 VITE_USER_POSTS_PATH から取得
 * デフォルト: /posts
 */
export const getUserPostsPath = (): string => {
  // 環境変数が明示的に設定されている場合はそれを使用
  if (import.meta.env.VITE_USER_POSTS_PATH) {
    return import.meta.env.VITE_USER_POSTS_PATH;
  }
  // デフォルトは /posts
  return '/posts';
};

/**
 * 管理画面のメディア一覧URLを取得
 * 環境変数 VITE_ADMIN_MEDIA_PATH から取得
 * デフォルト: /admin/media/list
 * 
 * 開発環境（localhost）では、URLから/devを削除して返す
 * 例: /dev/admin/media/list → /admin/media/list
 */
export const getAdminMediaListPath = (): string => {
  const path = import.meta.env.VITE_ADMIN_MEDIA_PATH || '/admin/media/list';
  
  // 開発環境（localhost）では/devを削除
  if (import.meta.env.DEV && path.startsWith('/dev/')) {
    return path.replace(/^\/dev/, '');
  }
  
  return path;
};

/**
 * 管理画面のカテゴリー一覧URLを取得
 * デフォルト: /admin/categories
 */
export const getAdminCategoriesPath = (): string => {
  return '/admin/categories';
};

/**
 * 管理画面のタグ一覧URLを取得
 * デフォルト: /admin/tags
 */
export const getAdminTagsPath = (): string => {
  return '/admin/tags';
};

